import './styles.css';

import nsdcMotif from '@assets/branding/nsdc.jpg';
import trentialMotif from '@assets/branding/trential-motif.svg';
import { DATA_TEST_IDS } from '@data-test-ids';

export default function Spinner() {
  return (
    <div
      className="loader-wrapper"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden',
        backgroundColor: '#ffffff',
        position: 'absolute',
        top: 0,
        left: 0
      }}>
      <span
        id="loader"
        style={{
          // backgroundColor: '#ffffff',
          borderBottom: `2px solid #037FFF`,
          borderTop: `2px solid #037FFF`
        }}>
        <span
          id=""
          style={{
            backgroundColor: '#ffffff'
          }}
        />
      </span>
      <img
        className="loading-img"
        src={import.meta.env.VITE_NSDC_PARTNER ? nsdcMotif : trentialMotif}
        alt={import.meta.env.VITE_ORG}
        data-test-id={DATA_TEST_IDS.SPINNER_LOGO}
      />
    </div>
  );
}
